import { BaseApi } from '@/core/api/base.api'
import {Room} from "@/core/api/room.api";
import {RoomUser} from "@/core/api/room.user.api"
import { roomQuestionService } from '@/core/service/room.question.service'
import _ from 'lodash'
import { RoomInfo } from '@/core/api/room.info.api'

class RoomQuestionApi extends BaseApi {
  #questionData = []

  constructor() {
    super(),
    Room.Question = this

    Room.ready(async e => {
      if(
        !RoomInfo.useModule('qna')
        || !RoomInfo.useModule('qnA')
      ){
        return;
      }

      this._eventListen(this.#Events);

      // 질문 리스트 조회
      await (async () => {
        const { data } = await roomQuestionService.questionList()
        this.#questionData = data
        Room.emit('room_question_init', this.#questionData)
      })();
    });
  }

  #Events = {
    // 질문 등록
    room_question_register(data) {
      this.#questionData.unshift(data.data.roomQuestion)

      Room.emit('room_question_renew', this.#questionData)

      if (RoomUser.hasEmceeRole()) {
        Room.emit('room_inform_new_question')
      }
    },
    room_question_change_status(data) {
      let questionId = data.data.roomQuestion.questionId
      let statusType = data.data.statusType
      let value = data.data.value

      switch(statusType) {
        case 'pin': {
          this.#questionData.find(qs => qs.questionId == questionId).isPin = value
          break
        }
        case 'del': {
          this.#questionData.splice(this.#questionData.findIndex(qs => qs.questionId == questionId), 1)
          break
        }
      }
      
      Room.emit(data)
    },

    // 댓글 등록
    room_question_comment_set(data) {
      this.#questionData.map(qs => {
        if (qs.questionId == data.data.comment.questionId) {
          return qs.comments.push(data.data.comment);
        }

        return qs;
      });

      Room.emit('room_question_comment_set', data.data.comment)
    },

    // 댓글 삭제
    room_question_comment_delete(data) {
      this.#questionData.map(qs => {
        if (qs.questionId == data.data.delObject.questionId) {
          qs.comments.map(c => {
            if (c.commentId == data.data.delObject.commentId) {
              c.isDel = true;
            }
          });
        }
        
        return qs;
      });

      Room.emit('room_question_comment_delete', data.data.delObject)
    },

    // 질문 공개 여부 변경
    room_question_info_set(data) {
      Room.emit('room_question_info_set', data.data);
    },

    // 질문 좋아요
    room_question_like_set(data) {
      const { commentLike } = data.data;

      this.#questionData.map(qs => {
        if (qs.questionId == commentLike.questionId) {
          qs.likes.push(commentLike);
        }
      });

      Room.emit('room_question_like_set', commentLike);
    },

    // 질문 좋아요 취소
    room_question_like_delete(data) {
      this.#questionData.map(qs => {
        if (qs.questionId == data.data.questionId) {
          qs.likes.splice(qs.likes.findIndex(like => like.likeId == data.data.likeId), 1);
        }
        return qs;
      });

      Room.emit('room_question_like_delete', data.data);
    }
  }

  async registerQuestion(content) {
    await roomQuestionService.registerQuestion({
      content
    })
  }

  async deleteQuestion(questionId) {
    await roomQuestionService.deleteQuestion({
      questionId
    })
  }

  async setQuestion({ questionId, statusType, value }) {
    await roomQuestionService.setQuestion({
      questionId,
      statusType,
      value
    })
  }

  // 댓글 공개 여부 변경
  async changeQuestionOpenStatus(params) {
    await roomQuestionService.changeQuestionOpenStatus(params)
  }

  // 댓글 등록
  async postComment(params) {
    await roomQuestionService.postComment(params);
  }

  // 댓글 삭제
  async deleteComments(params) {
    await roomQuestionService.deleteComments(params);
  }

  // 댓글 좋아요
  async likeComments(params) {
    await roomQuestionService.likeComments(params);
  }

  // 댓글 좋아요 취소
  async cancelLikeComments(params) {
    await roomQuestionService.cancelLikeComments(params);
  }
}

export const RoomQuestion = new RoomQuestionApi()
